import { render, staticRenderFns } from "./OverlayBox.vue?vue&type=template&id=28644119&scoped=true&"
import script from "./OverlayBox.vue?vue&type=script&lang=js&"
export * from "./OverlayBox.vue?vue&type=script&lang=js&"
import style0 from "./OverlayBox.vue?vue&type=style&index=0&id=28644119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28644119",
  null
  
)

export default component.exports